<template>
  <div v-if="location">
    <card class="mb-4" shadow noBody>
      <template v-slot:header>
        <div class="bg-white border-0">
          <div class="row align-items-top">
            <div class="col-8">
              <h3 class="mb-0">Dayforce Integration</h3>
            </div>
            <div class="col-4 text-right">
              <div v-if="!edit">
                <a href="#" @click.prevent="toggleEdit" class="text-sm">edit</a>
              </div>
              <div v-else>
                <a href="#" @click.prevent="toggleEdit" class="text-sm"
                  >cancel</a
                >
              </div>
            </div>
          </div>
        </div>
      </template>
      <div class="table-responsive">
        <!-- readonly -->
        <div v-if="!edit">
          <table class="table tablesorter">
            <tbody>
              <tr>
                <td class="align-middle" width="100">Dayforce Id 1</td>
                <td class="align-middle">
                  <div v-if="dayforceIds[0]">
                    {{ dayforceIds[0] }}
                  </div>
                  <div v-else>
                    <em class="text-sm text-muted"> n/a </em>
                  </div>
                </td>
                <td></td>
              </tr>
              <tr>
                <td class="align-middle" width="100">Dayforce Id 2</td>
                <td class="align-middle">
                  <div v-if="dayforceIds[1]">
                    {{ dayforceIds[1] }}
                  </div>
                  <div v-else>
                    <em class="text-sm text-muted"> n/a </em>
                  </div>
                </td>
                <td></td>
              </tr>
              <tr>
                <td class="align-middle" width="100">Dayforce Id 3</td>
                <td class="align-middle">
                  <div v-if="dayforceIds[2]">
                    {{ dayforceIds[2] }}
                  </div>
                  <div v-else>
                    <em class="text-sm text-muted"> n/a </em>
                  </div>
                </td>
                <td></td>
              </tr>
            </tbody>
          </table>
        </div>
        <!-- edit -->
        <form v-else @submit.prevent="saveDayforceIntegration">
          <table class="table tablesorter">
            <tbody class="">
              <tr>
                <td class="align-middle" width="100">Dayforce ID 1</td>
                <td>
                  <input
                    type="input"
                    placeholder=""
                    class="form-control form-control-alternative fw-bold"
                    v-model="inputs.dayforceId1"
                  />
                </td>
                <td></td>
              </tr>
              <tr>
                <td class="align-middle" width="100">Dayforce ID 2</td>
                <td>
                  <input
                    type="input"
                    placeholder=""
                    class="form-control form-control-alternative fw-bold"
                    v-model="inputs.dayforceId2"
                  />
                </td>
                <td></td>
              </tr>
              <tr>
                <td class="align-middle" width="100">Dayforce ID 3</td>
                <td>
                  <input
                    type="input"
                    placeholder=""
                    class="form-control form-control-alternative fw-bold"
                    v-model="inputs.dayforceId3"
                  />
                </td>
                <td></td>
              </tr>
              <tr>
                <td>
                  <input type="submit" value="Save" class="btn btn-primary" />
                </td>
                <td></td>
                <td></td>
              </tr>
            </tbody>
          </table>
        </form>
      </div>
    </card>
  </div>
</template>
<script>
export default {
  mounted() {
    this.setInputs();
  },
  components: {},
  props: ["location"],
  data() {
    return {
      edit: false,
      inputs: {},
    };
  },
  computed: {
    dayforceIds() {
      return this.location.dayforceIds || [];
    },
  },
  methods: {
    setInputs() {
      this.inputs.dayforceId1 = this.dayforceIds[0] || "";
      this.inputs.dayforceId2 = this.dayforceIds[1] || "";
      this.inputs.dayforceId3 = this.dayforceIds[2] || "";
    },
    toggleEdit() {
      this.setInputs();
      this.edit = !this.edit;
    },
    async saveDayforceIntegration() {
      const response = await this.$store.dispatch("callAPI", {
        action: "updateLocation",
        locationId: this.location.locationId,
        dayforceIds: [
          this.inputs.dayforceId1,
          this.inputs.dayforceId2,
          this.inputs.dayforceId3,
        ].filter((id) => id && id.trim()),
      });
      this.$emit("updated", response.data.data);
      this.edit = false;
    },
  },
};
</script>

<style lang="scss"></style>
